import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import '../../styles/BellonaYatak.css';
import { FaWhatsapp, FaTimes } from "react-icons/fa";

const BellonaYatak = () => {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isDetailOpen, setIsDetailOpen] = useState(false);
  
    useEffect(() => {
      // URL'deki hash'i kontrol et ve ilgili bölüme scroll et
      if (window.location.hash) {
        const element = document.getElementById(window.location.hash.substring(1));
        if (element) {
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      }
    }, []);
  
    const handleProductClick = (productId) => {
    // Ürün bilgisinin var olup olmadığını kontrol et
    if (products[productId]) {
      setSelectedProduct(productId);
      setIsDetailOpen(true);
      document.body.style.overflow = 'hidden'; // Scroll'u engelle
    } else {
      console.error('Ürün bulunamadı:', productId);
    }
  };

      const closeDetail = () => {
        setIsDetailOpen(false);
        setSelectedProduct(null);
        document.body.style.overflow = 'auto'; // Scroll'u geri aç
      };

    // Ürün bilgileri
  const products = {
    'all-seasons-baza': {
      name: 'All Seasons Comfort Baza',
      image: '../files/all-seasons-baza.jpg',
      description: 'Buklet kumaş kaplaması ile hem şık hem dayanıklı! All Seasons Comfort Baza, dört mevsim konfor sunan özel tasarımı ile yatak odalarınıza estetik ve fonksiyonellik katıyor. Baza, başlık ve baza ayak paketi ayrı satılmaktadır. Hybrid Buklet Vizon kumaş, uzun ömürlü ve kolay temizlenebilir.',
      price: "8.620,00 ₺'den başlayan fiyatlarla",
      features: [
        'Buklet kumaş kaplama',
        'Hybrid Buklet Vizon kumaş',
        'Baza, başlık ve baza ayak paketi ayrı satılır',
        'Kolay temizlenebilir yüzey',
        'Uzun ömürlü ve dayanıklı yapı',
        'Ücretsiz kurulum ve teslimat',
        '5 yıl garanti',
      ],
      dimensions: 'Farklı ölçülerde baza seçenekleri',
      material: 'Buklet kumaş, metal ve ahşap',
      warranty: '5 Yıl Garanti',
    },
    'boheemsleep-yatak': {
      name: 'BoheemSleep Yatak',
      image: '../files/boheemsleep-yatak.webp',
      description: 'BoheemSleep Yatağımız, bohem şıklığını ve modern tarzı bir araya getirerek estetik ve konforu kusursuzca yansıtır. Doğal keten içerikli nefes alabilen üst kumaşı ve pamuk içerikli yan kumaşı ile ferah bir uyku deneyimi sunmaya yardımcı olur. Ekstra sünger katmanlarıyla konforu en üst seviyeye taşır. Omurgayı destekleyen yapısı sayesinde farklı vücut tiplerine kusursuz uyum sağlar ve ideal bir uyku konforu sunar. Torba yay sistemi ile kusursuz destek.',
      price: "9.650,00 ₺'den başlayan fiyatlarla",
      features: [
        'Bohem şıklığı ve modern tarz',
        'Doğal keten içerikli nefes alabilen üst kumaş',
        'Pamuk içerikli yan kumaş',
        'Torba yay sistemi ile kusursuz destek',
        'Ekstra sünger katmanları ile üst düzey konfor',
        'Omurgayı destekleyen yapı',
        'Farklı vücut tiplerine uyum',
      ],
      dimensions: 'Farklı ölçülerde yatak seçenekleri',
      material: 'Doğal keten, pamuk, torba yay, sünger',
      warranty: '2 Yıl Garanti',
    },
    'soft-selection-yatak': {
      name: 'Soft Selection Pro 5 Yatak',
      image: '../files/soft-selection-yatak.webp',
      description: 'Soft Selection Pro 5 yatağımız, hava alabilen ve yumuşak dokulu örgü yatak kumaşı ile uyku konforunu en üst seviyeye çıkarır. 5 Bölgeli Torba Yay Sistemi ile desteklenen yatağımız, omurgaya mükemmel uyum sağlayarak vücut kıvrımlarına kusursuz şekilde adapte olur. Böylece omurganın doğal eğrisini korur. Ekstra konforlu sünger katmanları sayesinde benzersiz bir uyku deneyimi sunarken, çift taraflı kullanım imkânı ile uzun ömürlü bir kullanım sağlar.',
      price: "18.747,00 ₺'den başlayan fiyatlarla",
      features: [
        'Hava alabilen örgü kumaş',
        '5 bölgeli torba yay sistemi',
        'Çift taraflı kullanım',
        'Omurgaya mükemmel uyum',
        'Ekstra konforlu sünger katmanları',
        'Uzun ömürlü kullanım',
      ],
      material: 'Hava alabilen örgü kumaş, torba yay, sünger',
      warranty: '5 Yıl Garanti',
      dimensions: 'Farklı ölçülerde yatak seçenekleri',
      material: 'Doğal keten, pamuk, torba yay, sünger',
      warranty: '2 Yıl Garanti',
    },
    'magic-box-yastik': {
      name: 'Visco Magic Box Yastık',
      image: '../files/magic-box-yastik.webp',
      description: 'Visco Magic Box Yastık, visco elastik yapısı ile baş ve boyun desteğini maksimum seviyeye çıkarır. 50x70 cm ölçüsüyle ideal konfor sunar. Hava alabilen özel kumaşı sayesinde terleme yapmaz, gece boyunca ferah bir uyku sağlar. Modern kutu tasarımı ile hem şık hem fonksiyonel. Hipoalerjenik yapısı ile hassas ciltler için uygundur.',
      price: "1.209,00 ₺'den başlayan fiyatlarla",
      features: [
        'Visco elastik dolgu ile baş ve boyun desteği',
        'Hava alabilen özel kumaş',
        '50x70 cm standart ölçü',
        'Hipoalerjenik ve antibakteriyel',
        'Modern kutu tasarımı',
        'Uzun ömürlü ve dayanıklı yapı',
        'Terletmeyen nefes alabilen yüzey',
        'Direkt teslimat ve hızlı kargo',
      ],
      dimensions: '50 x 70 cm',
      material: 'Visco elastik dolgu',
      warranty: '2 Yıl Garanti',
    },
    'pure-touch-nevresim': {
      name: 'Pure Touch Nevresim Takımı',
      image: '../files/pure-touch-nevresim.webp',
      description: 'Pure Touch Nevresim Takımı, %100 pamuklu dokusu ile ekstra yumuşaklık ve nefes alabilirlik sunar. Modern ve zarif tasarımı ile yatak odanıza şıklık katar. Farklı renk ve ebat seçenekleriyle, her zevke ve ihtiyaca uygun. Hipoalerjenik yapısı ile hassas ciltler için ideal. Kolay yıkanabilir ve uzun ömürlü kullanım sağlar.',
      price: "899,00 ₺'den başlayan fiyatlarla",
      features: [
        '%65 pamuklu dokuma',
        'Ekstra yumuşak ve nefes alabilir',
        'Hipoalerjenik ve hassas ciltlere uygun',
        'Modern ve zarif tasarım',
        'Kolay yıkanabilir',
        'Uzun ömürlü kullanım',
        'Farklı renk ve ebat seçenekleri',
        'Gri ve kahve rengi mevcuttur',
      ],
      dimensions: 'Tek Kişilik / Çift Kişilik',
      material: '%65 pamuk, %35 pes',
      warranty: '1 Yıl Garanti',
    },
    'kaz-tuyu-yastik': {
      name: 'Deluxe Kaz Tüyü Yastık',
      image: '../files/kaz-tuyu-yastik.webp',
      description: 'Deluxe Kaz Tüyü Yastık, iki farklı katmana sahip olup dolgunluk sağlayan sırt tüyleri ve dış katmanda %70 oranında gıdık tüyü ile maksimum yumuşaklık ve rahatlık sunar. Dört mevsim kullanılabilen, %100 pamuk kumaşla desteklenmiş, lüks ve konforlu bir yastıktır. Ürüne özel şık tasarım, kolay taşınabilir, şeffaf pvc yüzey ve dayanıklı kulplar ile sunulmaktadır.',
      price: "3.169,00 ₺'den başlayan fiyatlarla",
      features: [
        'İki katmanlı kaz tüyü dolgu',
        'Dış katmanda %70 gıdık tüyü',
        'Sırt tüyleri ile dolgunluk',
        'Maksimum yumuşaklık ve rahatlık',
        'Dört mevsim kullanım',
        '%100 pamuk kumaş yüzey',
        'Ürüne özel şık tasarım',
        'Kolay taşınabilir, dayanıklı kulplar',
        'Şeffaf pvc yüzey',
        'Lüks ve estetik',
      ],
      dimensions: 'Standart yastık ölçüsü',
      material: 'Kaz tüyü dolgu, %100 pamuk kumaş',
      warranty: '2 Yıl Garanti',
    },
  }

  return (
    <div className="bellona-yatak">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <div className="brand-logo">
              <img src="../files/bellona-logo.png" alt="Bellona Yatak Logo" />
            </div>
            <h1>Bellona Yatak Koleksiyonu</h1>
            <p>Kaliteli uyku ve konfor için premium yatak çözümleri</p>
          </div>
        </section>

        {/* Products Section */}
        <section className="products-section">
          <div className="container">
            <h2>Yatak Kategorilerimiz</h2>

            {/* Yatak, Baza, Başlık Setleri */}
            <div className="category-section" id="yatak">
              <h3 className="category-title">🛏️ Yatak, Baza, Başlık</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/all-seasons-baza.jpg" alt="Yataş Visco Yatak 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('all-seasons-baza')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>All Seasons Comfort Baza</h4>
                    <p>Buklet kumaş ile üretilmiş konforlu bir baza</p>
                    <div className="product-features">
                      <span className="feature">✓ Buklet kumaş kaplama</span>
                      <span className="feature">✓ Kolay temizlenebilir yüzey</span>
                      <span className="feature">✓ Uzun ömürlü ve dayanıklı yapı</span>
                    </div>
                    <div className="product-price">
                      <span className="price">8.620,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/boheemsleep-yatak.webp" alt="Yataş Visco Yatak 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('boheemsleep-yatak')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>BoheemSleep Yatak</h4>
                    <p>Bohem şıklığı, doğal içerikli kumaş ve torba yay sistemi ile üst düzey konfor</p>
                    <div className="product-features">
                      <span className="feature">✓ Doğal keten içerikli üst kumaş</span>
                      <span className="feature">✓ Torba yay sistemi ile kusursuz destek</span>
                      <span className="feature">✓ Omurgayı destekleyen yapı</span>
                    </div>
                    <div className="product-price">
                      <span className="price">9.650,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/soft-selection-yatak.webp" alt="Yataş Visco Yatak 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('soft-selection-yatak')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Soft Selection Pro 5 Yatak</h4>
                    <p>Hava alabilen örgü kumaş, 5 bölgeli torba yay sistemi ve çift taraflı kullanım</p>
                    <div className="product-features">
                      <span className="feature">✓ Hava alabilen örgü kumaş</span>
                      <span className="feature">✓ Çift taraflı kullanım</span>
                      <span className="feature">✓ Omurgaya mükemmel uyum</span>
                    </div>
                    <div className="product-price">
                      <span className="price">18.747,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tekstil */}
            <div className="category-section" id="tekstil">
              <h3 className="category-title">🧵 Tekstil</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/magic-box-yastik.webp" alt="Visco Magic Box Yastık" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('magic-box-yastik')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Visco Magic Box Yastık</h4>
                    <p>Visco elastik dolgu, hava alabilen kumaş ve modern tasarımı ile maksimum konfor</p>
                    <div className="product-features">
                      <span className="feature">✓ Visco elastik baş ve boyun desteği</span>
                      <span className="feature">✓ Hava alabilen özel kumaş</span>
                      <span className="feature">✓ Hipoalerjenik</span>
                    </div>
                    <div className="product-price">
                      <span className="price">1.209,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/pure-touch-nevresim.webp" alt="Pure Touch Nevresim Takımı" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('pure-touch-nevresim')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Pure Touch Nevresim Takımı</h4>
                    <p>%65 pamuklu dokusu, ekstra yumuşaklık ve modern tasarım</p>
                    <div className="product-features">
                      <span className="feature">✓ %65 pamuk</span>
                      <span className="feature">✓ Ekstra yumuşak</span>
                      <span className="feature">✓ Hipoalerjenik</span>
                    </div>
                    <div className="product-price">
                      <span className="price">899,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/kaz-tuyu-yastik.webp" alt="Bellona Tekstil 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('kaz-tuyu-yastik')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Deluxe Kaz Tüyü Yastık</h4>
                    <p>İki katmanlı kaz tüyü dolgu, %100 pamuk kumaş, şık ve taşınabilir tasarım</p>
                    <div className="product-features">
                      <span className="feature">✓ İki katmanlı kaz tüyü</span>
                      <span className="feature">✓ %100 pamuk kumaş</span>
                      <span className="feature">✓ Şık ve taşınabilir tasarım</span>
                    </div>
                    <div className="product-price">
                      <span className="price">3.169,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <h2>Yataş Yatak Avantajları</h2>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">🏆</div>
                <h3>60 Yıllık Deneyim</h3>
                <p>Türkiye'nin en köklü yatak markası</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔬</div>
                <h3>Ar-Ge Merkezi</h3>
                <p>Sürekli araştırma ve geliştirme</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🌿</div>
                <h3>Doğal Malzemeler</h3>
                <p>Çevre dostu ve sağlıklı malzemeler</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">💤</div>
                <h3>Uyku Uzmanı</h3>
                <p>Kaliteli uyku için bilimsel yaklaşım</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="container">
            <div className="contact-content">
              <h2>Daha Fazlası İçin Bizimle İletişime Geçin</h2>
              <p>Yataş Yatak ürünleri hakkında detaylı bilgi almak ve fiyat teklifi için bize ulaşın.</p>
              <div className="contact-buttons">
                <a href="tel:+905496250335" className="btn btn-primary">📞 Hemen Ara</a>
                <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <FaWhatsapp style={{ marginRight: 8, fontSize: 20, verticalAlign: 'middle' }} />
                  WhatsApp
                </a>
                <Link to="/kurumsal" className="btn btn-outline">🏪 Mağazamızı Ziyaret Edin</Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Product Detail Modal */}
      {isDetailOpen && selectedProduct && products[selectedProduct] && (
        <div className="product-detail-modal">
          <div className="modal-overlay" onClick={closeDetail}></div>
          <div className="modal-content">
            <button className="close-button" onClick={closeDetail}>
              <FaTimes />
            </button>
            
            <div className="modal-body">
              <div className="product-image-section">
                <img 
                  src={products[selectedProduct]?.image || '../files/traverta-yatak-odasi.webp'} 
                  alt={products[selectedProduct]?.name || 'Ürün'}
                  className="detail-image"
                />
              </div>
              
              <div className="product-info-section">
                <h2>{products[selectedProduct]?.name || 'Ürün Adı'}</h2>
                <p className="product-description">{products[selectedProduct]?.description || 'Açıklama bulunamadı'}</p>
                
                <div className="product-details">
                  <h3>Özellikler</h3>
                  <ul className="features-list">
                    {(products[selectedProduct]?.features || []).map((feature, index) => (
                      <li key={index}>✓ {feature}</li>
                    ))}
                  </ul>
                  
                  <div className="specifications">
                    <h3>Teknik Özellikler</h3>
                    <div className="spec-item">
                      <strong>Boyutlar:</strong> {products[selectedProduct]?.dimensions || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item">
                      <strong>Malzeme:</strong> {products[selectedProduct]?.material || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item">
                      <strong>Garanti:</strong> {products[selectedProduct]?.warranty || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item price">
                      <strong>Fiyat:</strong> {products[selectedProduct]?.price || 'Fiyat için iletişime geçin'}
                    </div>
                  </div>
                  
                  <div className="action-buttons">
                    <a href="tel:+905496250335" className="btn btn-primary">
                      📞 Fiyat Bilgisi Al
                    </a>
                    <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                      <FaWhatsapp style={{ marginRight: 8 }} size={25}/>
                      WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default BellonaYatak;
